import { render, staticRenderFns } from "./AddSubjectDialog.vue?vue&type=template&id=4547bf4d&scoped=true&"
import script from "./AddSubjectDialog.ts?vue&type=script&lang=ts&"
export * from "./AddSubjectDialog.ts?vue&type=script&lang=ts&"
import style0 from "./add-subject-dialog.scss?vue&type=style&index=0&id=4547bf4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547bf4d",
  null
  
)

export default component.exports